import Util from 'app/util'

import getters from './games/getters.js'
import mutations from './games/mutations.js'
import actions from './games/actions.js'

export default {

	namespaced: true,

	state: {

		name: 'plays',

		route: 'Plays',

		data: Util.filter.templates.plays(),

		defaultValues: Util.filter.templates.plays(),

		preset: 0,

		changed: false

	},
	
	getters: getters,
	mutations: mutations,
	actions: actions

}